// 공통 API 경로 상수
export const METADATA_BASE = '/v1.0/metadata';
export const PROJECT_BASE = '/v1.0/project';
export const USER_BASE = '/v1.0/user';
export const ME_BASE = '/v1.0/me';
export const API_BASE = '/v1.0/api';
export const AUTHORITY_BASE = '/v1.0/authority';
export const GROUP_BASE = '/v1.0/group';
export const MENU_BASE = '/v1.0/menu';
export const SYSTEM_BASE = '/v1.0/system';
export const BOARD_BASE = '/v1.0/board';
export const FILE_BASE = '/v1.0/files';
export const ADMIN_FILE_CATEGORY_BASE = '/v1.0/admin/file-categories';
